import React from "react";
import { cn } from "../../lib/cn";

export interface ThemeToggleProps {
  checked: boolean;
  onToggle: () => void;
  className?: string;
}

const ThemeToggle = ({ checked, onToggle, className }: ThemeToggleProps) => {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={checked ? "Switch to light mode" : "Switch to dark mode"}
      onClick={onToggle}
      className={cn(
        "inline-flex items-center gap-3 rounded-full border border-white/60 bg-white/60 px-3 py-2 text-sm text-gray-700 shadow-sm backdrop-blur-sm transition-colors hover:bg-white dark:border-gray-700 dark:bg-gray-900/70 dark:text-gray-200 dark:hover:bg-gray-900",
        className,
      )}
    >
      <span
        className={cn(
          "relative h-6 w-11 rounded-full transition-colors",
          checked ? "bg-orange-500" : "bg-gray-300 dark:bg-gray-700",
        )}
      >
        <span
          className={cn(
            "absolute top-0.5 h-5 w-5 rounded-full bg-white shadow-sm transition-transform",
            checked ? "translate-x-5 left-0.5" : "translate-x-0 left-0.5",
          )}
        />
      </span>
      <span>{checked ? "Dark" : "Light"}</span>
    </button>
  );
};

export default ThemeToggle;
